import request from '../utils/request'

// 9.30
// 登录
export function postLoginBabe(data) {
  return request({
    url: 'api/babe/user/login',
    method: 'post',
    data: data
  })
}

// 个人信息
export function postUserInfoBabe(data) {
  return request({
    url: 'api/babe/user/info',
    method: 'post',
    data: data
  })
}

// 我的NFT
export function postBabeNftMynft(data) {
  return request({
    url: 'api/babe/nft/mynft',
    method: 'post',
    data: data
  })
}

// NFT详情
export function postBabeNftInfo(data) {
  return request({
    url: 'api/babe/nft/info',
    method: 'post',
    data: data
  })
}

// 10.1
// 热门NFT
export function postBabeNftHots(data) {
  return request({
    url: 'api/babe/nft/hots',
    method: 'post',
    data: data
  })
}

// 热门活动
export function postActivityHots(data) {
  return request({
    url: 'api/babe/activity/hots',
    method: 'post',
    data: data
  })
}

// 图片上传
export function postBabeImageUpload(data) {
  return request({
    url: 'api/babe/image/upload',
    method: 'post',
    data: data
  })
}

// 个人信息修改
export function postBabeUserUpdate(data) {
  return request({
    url: 'api/babe/user/update',
    method: 'post',
    data: data
  })
}

// 10.2
// 退出登录
export function postBabeUserLogout(data) {
  return request({
    url: 'api/babe/user/logout',
    method: 'post',
    data: data
  })
}

// 10.6
// 活动详情
export function postActivityInfoBabe(data) {
  return request({
    url: 'api/babe/activity/info',
    method: 'post',
    data: data
  })
}

// 参与活动排行
export function postActivityRankBabe(data) {
  return request({
    url: 'api/babe/activity/rank',
    method: 'post',
    data: data
  })
}

// 10.7
// 邀请激活
export function postBabeInviteConfirm(data) {
  return request({
    url: 'api/babe/invite/confirm',
    method: 'post',
    data: data
  })
}

// 10.20
// 邀请激活
export function postBabeGames(data) {
  return request({
    url: 'api/babe/games',
    method: 'post',
    data: data
  })
}

// 10.28
// 出入金日志
export function postBabeTransferLog(data) {
  return request({
    url: 'api/babe/user/transfer_log',
    method: 'post',
    data: data
  })
}

// 10.31
// 获取题目
export function postBabeQuestionGet(data) {
  return request({
    url: 'api/babe/question/get',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/babe.js